import axios from "@/libs/api.request";

export const getSimpleList = () =>
  axios.request({
    url: "/system/dict-data/simple-list",
    method: "get",
  });
